import React from 'react'

import MiscHeading from '@pc/components/Works/Panel/shared/heading/MiscHeading'
import FeatureItem from './FeatureItem'
import FeatureBox from './FeatureBox'
import type { FeatureCategory, Feature } from '@pc/components/Works/Panel/type'

interface PropsType {
  featureCategories: FeatureCategory[]
  mappedFeatures: Record<string, Feature[]>
  selectedFeatureIds: string[]
  changeState: (arg: any) => void
}

const FeatureList = (props: PropsType) => {
  const { featureCategories, mappedFeatures, selectedFeatureIds, changeState } = props

  return (
    <>
      {featureCategories.map((featureCategory) => {
        const { id, attributes } = featureCategory
        return (
          <FeatureBox key={id}>
            <MiscHeading>{attributes.name}</MiscHeading>
            <FeatureItem features={mappedFeatures[id]} selectedFeatureIds={selectedFeatureIds} changeState={changeState} />
          </FeatureBox>
        )
      })}
    </>
  )
}

export default FeatureList
